import gql from 'graphql-tag';

export default gql`
  mutation updateCustomRedirect($id: Int!, $permanent: Boolean!) {
    update_custom_redirects_by_pk(pk_columns: { id: $id }, _set: { permanent: $permanent }) {
      id
    }
  }
`;
